module.exports = __webpack_public_path__ + "static/media/logo-esrb-e.f804cfdb.svg";